import * as api from '../api'
import { STORE_SUPPORT_ITEMS, LOADING_START, LOADING_END, STORE_CURRENT_SUPPORT_ITEM } from '../constants/actionConstants';

// Return all of the support items in the database
export const fetchSupportItems = () => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchSupportItems() ; 
        dispatch({type: STORE_SUPPORT_ITEMS, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        console.log(error.message) ; 
    }
}

// Return all of the support items in the database
export const fetchSupportItemById = (id) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchSupportItemById(id) ; 
        dispatch({type: STORE_CURRENT_SUPPORT_ITEM, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        console.log(error.message) ; 
    }
}

// Return all of the support items in the database
export const duplicateSupportItemById = (id) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        console.log("Calling API")
        const {data} = await api.duplicateSupportItemById(id) ; 
        dispatch({type: STORE_CURRENT_SUPPORT_ITEM, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        console.log(error.message) ; 
    }
}

// Return all of the support items in the database
export const deleteSupportItemById = (id) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.deleteSupportItemById(id) ; 
        dispatch({type: STORE_CURRENT_SUPPORT_ITEM, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        // If an error, then failed to login;  navigate back to the home page
        console.log(error.message) ; 
    }
}


// Create or update support item
export const updateSupportItem= (support) => async (dispatch) => {
    try{
        // If it already exists (has an ID) then update, otherwise create
        if(support.hasOwnProperty('_id')){
            console.log("Updating support: ", support)
            await api.updateSupportItem(support._id, support) ; 
        }
        else{
            console.log("Creating support")
            const new_support = await api.createSupportItem(support) ; 
            console.log(new_support.data)
            dispatch({type: STORE_CURRENT_SUPPORT_ITEM, payload: new_support.data});
        }
    } catch (error) {
        console.log(error) ;
        throw error ;
    }
}

